import type { FloorId } from '@/data/floors';

export type FloorUpgradeEffekt =
  | { type: 'manus_per_dag_bonus'; verdi: number }
  | { type: 'kampanje_pris_rabatt'; verdi: number }
  | { type: 'fase_dager_rabatt'; fase: 'redigering' | 'design' | 'trykk'; verdi: number }
  | { type: 'salg_bonus_global'; verdi: number }
  | { type: 'lojalitet_decay_redusert'; verdi: number }
  | { type: 'dashboard_sesong_prognose' }
  | { type: 'omdomme_per_uke'; verdi: number };

export type FloorUpgradeEffektType = FloorUpgradeEffekt['type'];

export type FloorUpgradeEffektAv<T extends FloorUpgradeEffektType> = Extract<
  FloorUpgradeEffekt,
  { type: T }
>;

export type FloorUpgrade = {
  floorId: FloorId;
  pris: number;
  navn: string;
  beskrivelse: string;
  effekter: FloorUpgradeEffekt[];
};

export const FLOOR_UPGRADES: Record<FloorId, FloorUpgrade> = {
  redaksjon: {
    floorId: 'redaksjon',
    pris: 80_000,
    navn: 'Større redaksjon',
    beskrivelse: '3 redaktører i stedet for 1. +1 manus i innboksen hver dag.',
    effekter: [{ type: 'manus_per_dag_bonus', verdi: 1 }],
  },
  resepsjon: {
    floorId: 'resepsjon',
    pris: 40_000,
    navn: 'Modernisert resepsjon',
    beskrivelse: 'Bedre møte-rom og kaffe. Forfattere blir mer lojale.',
    effekter: [{ type: 'lojalitet_decay_redusert', verdi: 0.5 }],
  },
  bokhandel: {
    floorId: 'bokhandel',
    pris: 60_000,
    navn: 'Full bokhandel-foajé',
    beskrivelse: 'Egen retail-flate i 1. etasje. +10 % salg på alle bøker.',
    effekter: [{ type: 'salg_bonus_global', verdi: 0.1 }],
  },
  design: {
    floorId: 'design',
    pris: 50_000,
    navn: 'Eget design-team',
    beskrivelse: 'Tre designere på heltid. Design-fasen kuttes med 1 dag.',
    effekter: [{ type: 'fase_dager_rabatt', fase: 'design', verdi: 1 }],
  },
  marked: {
    floorId: 'marked',
    pris: 100_000,
    navn: 'Eget PR-team',
    beskrivelse: 'Eget marked- og PR-byrå. 15 % rabatt på alle kampanjer.',
    effekter: [{ type: 'kampanje_pris_rabatt', verdi: 0.15 }],
  },
  direksjon: {
    floorId: 'direksjon',
    pris: 70_000,
    navn: 'Strategi-rom',
    beskrivelse: 'Sesong-prognose vises i dashboardet. Klar for analytikere.',
    effekter: [{ type: 'dashboard_sesong_prognose' }],
  },
  tak: {
    floorId: 'tak',
    pris: 120_000,
    navn: 'Møblert takterrasse',
    beskrivelse: 'Strengelys og vinglass. +2 omdømme per uke fra mingling.',
    effekter: [{ type: 'omdomme_per_uke', verdi: 2 }],
  },
  kjeller: {
    floorId: 'kjeller',
    pris: 90_000,
    navn: 'Automatisert trykkeri',
    beskrivelse: 'Egen presse i kjelleren. Trykk-fasen kuttes med 1 dag.',
    effekter: [{ type: 'fase_dager_rabatt', fase: 'trykk', verdi: 1 }],
  },
};

export function finnFloorUpgrade(id: FloorId): FloorUpgrade {
  return FLOOR_UPGRADES[id];
}
